"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var client_1 = require("./client");

exports.Notifications = client_1.Client;